<template>
	<v-container fluid>
      <div class="text-center text-h3">
        Reporte de Incidencias del Día Anterior ({{ fechaAnteriorFormateada }})
      </div>
		<!-- <v-row class="text-center">
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="filtros.idArea"
					:items="areas"
					item-value="idArea"
					item-text="nombre"
					label="Área"
					hide-details
					:disabled="nombreEmpresa === 'Nyx'"
					@change="getSeries()"
				></v-autocomplete>
			</v-col>
			<v-col v-if="nombreEmpresa === 'Nyx'" cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-autocomplete
					v-model="idTurno"
					:items="turnos"
					item-text="nombre"
					item-value="idTurno"
					label="Turno"
					hide-details
					:disabled="nombreEmpresa === 'Nyx'"
				></v-autocomplete>
			</v-col>
			<v-col cols="4" md="4" sm="4" class="mt-0 pt-0">
				<v-select
					v-model="filtros.idOEEFactor"
					:items="oeeFactores"
					item-value="idOEEFactor"
					item-text="nombre"
					label="Factor OEE"
					hide-details
					clearable
					:disabled="nombreEmpresa === 'Nyx'"
					@change="getSeries()"
				></v-select>
			</v-col>
		</v-row> -->


		<div style="position: relative;">
			<div
				style="
				position: absolute;
				top: 8px;
				right: 120px; /* <- este valor ajusta la alineación exacta */
				font-weight: bold;
				font-size: 16px;
				z-index: 10;
				background: white;
				padding: 2px 6px;
				">
				SubCausas
			</div>

			<apexchart
				type="bar"
				height="350"
				:options="chartOptions"
				:series="series"
			></apexchart>
		</div>
	</v-container>
</template>

<script>
import axios from "axios";
import {mapState} from "vuex";
export default {
	data() {
		return {
			tiposParos: [
				{
					id: 1,
					value: "Sensor",
				},
				{
					id: 2,
					value: "Manual",
				},
			],
			instancias: [],
			personas: [],
			operadores: [],
			articulosFase: [],
			articulosProducir: [],
			claves: [],
			areas: [],
			tipoSubparos: [],
			tipoParos: [],
			oeeFactores: [],
			previewVisible: false,
    		previewUrl: null,
			turnos: [],
			idTurno: null,
			tipoIncidencias: [
				{
					id: true,
					text: "Paro",
				},
				{
					id: false,
					text: "Reporte",
				},
			],
			filtros: {
				idTipoParo: null,
				idOEEFactor: 3,
				idParoTipo: null,
				idSubParoTipo: null,
				clave: null,
				idArticuloProducir: null,
				idArticuloFase: null,
				idArea: null,
				idReporto: null,
				idResponsable: null,
				inicio: null,
				fin: null,
				bloqueoProduccion: false,
				idTurno: null
			},
			series: [],
			chartOptions: null,
			loading: false,
			dialogVisible: false,
			selectedData: {
				category: '',
				serie: '',
				valor: 0,
			},
			paros: [], 
    		paros_total: 0,
    		paros_actual_page: 1,
    		paros_items_per_page: 10,
			parosRelacionados: [], 
		};
	},
	created(){
		const rango = this.fechaPorDefecto();
		this.filtros.inicio = rango.inicio;
		this.filtros.fin = rango.fin;
		this.initialize();
	},
	computed: {
		fechaAnteriorFormateada() {
			const fechaStr = this.filtros.inicio;
			if (!fechaStr) return '';
			const [datePart] = fechaStr.split(' ');
			const [yyyy, mm, dd] = datePart.split('-');
			return `${dd}-${mm}-${yyyy}`;
		},
		...mapState({
			nombreEmpresa: "nombreEmpresa"
		}),
		subTipoParoFiltrados() {
			if (this.$utils.isValid(this.filtros.idParoTipo))
				return this.tipoSubparos.filter(
					(tp) => tp.idParoTipo == this.filtros.idParoTipo
				);
			else return this.tipoSubparos;
		},
		tipoParosFiltrados() {
			if (
				this.$utils.isValid(this.filtros.idOEEFactor) &&
				this.filtros.idOEEFactor >= 0
			) {
				const idOEEFactor =
					this.filtros.idOEEFactor == 0
						? null
						: this.filtros.idOEEFactor;
				return this.tipoParos.filter(
					(tp) => tp.idOEEFactor == idOEEFactor
				);
			} else {
				return this.tipoParos;
			}
		},
	},
	beforeMount() {
		this.setDefaultsChart();
	},
	// watch: {
	// nombreEmpresa(newVal) {
	// 	if (newVal === 'Nyx') {
	// 	this.filtros.idTipoParo = 2;
	// 	this.filtros.idOEEFactor = 3;
	// 	}
	// }
	// },
	mounted() {
		if (this.nombreEmpresa === 'Nyx') {
			this.filtros.idTipoParo = 2;
			this.filtros.idOEEFactor = 3;
		} else if (this.nombreEmpresa === 'Glm') {
			this.filtros.idTipoParo = 4;
			this.filtros.idOEEFactor = 3;
		}
	},
	methods: {
		nombrePersona: (persona) =>
			persona.nombre + " " + persona.paterno + " " + persona.materno,
		initialize() {
			this.getSeries();
			this.getOEEFactores();
			this.getTipoParos();
			this.getTipoSubParos();
			this.getPersonas();
			this.getOperadores();
			this.getClaves();
			this.getArticulosProducir();
			this.getArticulosFase();
			this.getAreas();
			this.getAreasNyx();
			this.getTurnos();
			this.getInstancias();
		},
		getPersonas() {
			axios
				.get("/Personas")
				.then((response) => {
					this.personas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getOperadores() {
			axios
				.get("/Personas/Operadores")
				.then((response) => {
					this.operadores = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getArticulosFase() {
			axios
				.get("/Articulos/ArticulosNombres?componentes=true")
				.then((response) => {
					this.articulosFase = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getArticulosProducir() {
			axios
				.get("/Articulos/OTS")
				.then((response) => {
					this.articulosProducir = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getClaves() {
			axios
				.get("/TrabajoOrdenes/TrabajoOrdenHeaders")
				.then((response) => {
					this.claves = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getAreas() {
			axios
				.get("/Areas")
				.then((response) => {
					this.areas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getAreasNyx() {
			axios
				.get("/Areas")
				.then((response) => {
				this.areas = response.data;
				if (this.nombreEmpresa === 'Nyx') {
					const defaultId = 6;
					const areaEncontrada = this.areas.find(area => area.idArea === defaultId);
					if (areaEncontrada) {
					this.filtros.idArea = defaultId;
					}
				} else if (this.nombreEmpresa === 'Glm') {
					// Para Glm todas las áreas de momento
					this.filtros.idArea = null;
				}
				this.getSeries();
				})
				.catch((error) => {
				console.log(error);
				});
		},
	// 	fechaPorDefectoNyx() { //simulamos turnos
	// 		const now = new Date();
	// 		const pad = n => n < 10 ? '0' + n : n;
	// 		const fecha = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
	// 		const horaActual = `${pad(now.getHours())}:${pad(now.getMinutes())}`;

	// 		// Define los turnos
	// 		const turnos = [
	// 			{ inicio: "07:01", fin: "16:30" },   // Turno 1
	// 			{ inicio: "16:31", fin: "01:30" },   // Turno 2
	// 			{ inicio: "01:31", fin: "07:00" }    // Turno 3
	// 		];

	// 		// Convierte hora a minutos
	// 		const aMinutos = (horaStr) => {
	// 			const [h, m] = horaStr.split(":").map(Number);
	// 			return h * 60 + m;
	// 		};
	// 		const minutosActuales = now.getHours() * 60 + now.getMinutes();

	// 		let inicioTurno = turnos[0].inicio;
	// 		let fechaInicio = new Date(now);

	// 		// Detecta el turno actual correctamente
	// 		for (const turno of turnos) {
	// 			const minInicio = aMinutos(turno.inicio);
	// 			const minFin = aMinutos(turno.fin);

	// 			if (minInicio < minFin) {
	// 			// Turno normal (no cruza medianoche)
	// 			if (minutosActuales >= minInicio && minutosActuales < minFin) {
	// 				inicioTurno = turno.inicio;
	// 				break;
	// 			}
	// 			} else {
	// 			// Turno que cruza medianoche
	// 			// Ejemplo: 16:30 - 01:30 o 01:30 - 07:00
	// 			if (
	// 				(minutosActuales >= minInicio && minutosActuales < 1440) || // después del inicio hasta medianoche
	// 				(minutosActuales >= 0 && minutosActuales < minFin)          // desde medianoche hasta fin
	// 			) {
	// 				inicioTurno = turno.inicio;
	// 				// Si la hora actual es después de medianoche pero antes del fin, y el turno inicia ayer
	// 				if (minutosActuales < minFin) {
	// 				fechaInicio.setDate(fechaInicio.getDate() - 1);
	// 				}
	// 				break;
	// 			}
	// 			}
	// 		}

	// 		 const fechaInicioStr = `${fechaInicio.getFullYear()}-${pad(fechaInicio.getMonth() + 1)}-${pad(fechaInicio.getDate())}+${inicioTurno}`;
   	// 		 const fechaFinStr = `${fecha}+${horaActual}`;

	// 		return {
	// 			inicio: fechaInicioStr,
	// 			fin: fechaFinStr
	// 		};
	// },
	// fechaPorDefectoGlm() {
    //   const now = new Date();
    //   const pad = n => n < 10 ? '0' + n : n;
    //   const fecha = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    //   const horaActual = `${pad(now.getHours())}:${pad(now.getMinutes())}`;

    //   const turnos = [
    //     { inicio: "07:01", fin: "15:00" }, 
    //     { inicio: "15:01", fin: "22:30" }, 
    //     { inicio: "22:31", fin: "07:00" }  
    //   ];

    //   const aMinutos = (horaStr) => {
    //     const [h, m] = horaStr.split(":").map(Number);
    //     return h * 60 + m;
    //   };
    //   const minutosActuales = now.getHours() * 60 + now.getMinutes();

    //   let inicioTurno = turnos[0].inicio;
    //   let fechaInicio = new Date(now);

    //   for (const turno of turnos) {
    //     const minInicio = aMinutos(turno.inicio);
    //     const minFin = aMinutos(turno.fin);

    //     if (minInicio < minFin) {
    //       // Turno normal (no cruza medianoche)
    //       if (minutosActuales >= minInicio && minutosActuales < minFin) {
    //         inicioTurno = turno.inicio;
    //         break;
    //       }
    //     } else {
    //       // Turno que cruza medianoche (solo el turno 3)
    //       if (
    //         (minutosActuales >= minInicio && minutosActuales < 1440) || // después del inicio hasta medianoche
    //         (minutosActuales >= 0 && minutosActuales < minFin)          // desde medianoche hasta fin
    //       ) {
    //         inicioTurno = turno.inicio;
    //         if (minutosActuales < minFin) {
    //           fechaInicio.setDate(fechaInicio.getDate() - 1);
    //         }
    //         break;
    //       }
    //     }
    //   }

    //   const fechaInicioStr = `${fechaInicio.getFullYear()}-${pad(fechaInicio.getMonth() + 1)}-${pad(fechaInicio.getDate())}+${inicioTurno}`;
    //   const fechaFinStr = `${fecha}+${horaActual}`;

    //   return {
    //     inicio: fechaInicioStr,
    //     fin: fechaFinStr
    //   };
    // },
fechaPorDefecto() {
      const hoy = new Date();
      // Restamos un día
      hoy.setDate(hoy.getDate() - 1);

      const yyyy = hoy.getFullYear();
      const mm   = String(hoy.getMonth() + 1).padStart(2, '0');
      const dd   = String(hoy.getDate()).padStart(2, '0');

      const fecha = `${yyyy}-${mm}-${dd}`;
      return {
        inicio: `${fecha} 00:00`,
        fin:    `${fecha} 23:59`
      };
    },
    // obtenerFechasPorEmpresa() {
    //   if (this.nombreEmpresa === 'Nyx') {
    //     return this.fechaPorDefectoNyx();
    //   } else if (this.nombreEmpresa === 'Glm') {
    //     return this.fechaPorDefectoGlm();
    //   }
    // },
		getTurnos() {
			axios
			.get("/Turnos")
			.then((response) => {
				this.turnos = response.data;
				//this.detectarTurnoActual();
				this.getSeries();
				//console.log("los turnos son:", this.turnos);
			})
			.catch((error) => {
				console.log(error);
			});
		},
		detectarTurnoActual() {
			const ahora = new Date();
			const minutosActuales = ahora.getHours() * 60 + ahora.getMinutes();

			const convertirAHoras = (horaStr) => {
				const [h, m] = horaStr.split(":").map(Number);
				return h * 60 + m;
			};

			for (const turno of this.turnos) {
				const inicio = convertirAHoras(turno.inicio);
				const fin = convertirAHoras(turno.fin);

				if (inicio < fin) {
				// Turno normal
				if (minutosActuales >= inicio && minutosActuales < fin) {
					this.filtros.idTurno = turno.idTurno;
					break;
				}
				} else {
				// Turno que cruza medianoche
				if (minutosActuales >= inicio || minutosActuales < fin) {
					this.filtros.idTurno = turno.idTurno;
					break;
				}
				}
			}
		},
		getTipoSubParos() {
			axios
				.get("/SubParoTipos")
				.then((response) => {
					this.tipoSubparos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		changeParoTipo() {
			this.filtros.idSubParoTipo = null;
			this.getSeries();
		},
		getTipoParos() {
			axios
				.get("/ParoTipos")
				.then((response) => {
					this.tipoParos = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getInstancias(){
			axios
				.get("/MaquinaInstancias")
				.then( response => {
					this.instancias = response.data;
				})
				.catch( error => {
					console.log(error);
				})
		},
		getOEEFactores() {
			axios
				.get("/OEEFactores")
				.then((response) => {
					this.oeeFactores = response.data;
					console.log("los factores son: ", this.oeeFactores);
					this.oeeFactores.push({
						idOEEFactor: 0,
						nombre: "SIN ESPECIFICAR",
						descripcion: "Sin Especificar",
					});
				})
				.catch((error) => {
					console.log(error);
				});
		},
		// getOEEFactoresNyx() {
		//   axios
		// 	.get("/OEEFactores")
		// 	.then((response) => {
		// 	this.oeeFactores = response.data;
		// 	const defaultId = 3;
		// 	const oeeEncontrado = this.oeeFactores.find(area => area.idArea === defaultId);
		// 	if (oeeEncontrado) {
		// 	  this.filtros.idOEE = defaultId;
		// 	  this.getSeries(); 
		// 	}
		// 	})
		// 	.catch((error) => {
		// 	console.log(error);
		// 	});
		// },
		getSeries() {
			this.loading = true;

			axios
				.get("/Paros/GraficaParos", {
					params: {
						paginar: false,
						idParoTipo: this.filtros.idParoTipo,
						idSubParoTipo: this.filtros.idSubParoTipo,
						idTrabajoOrden: this.filtros.clave,
						idArticuloProducir: this.filtros.idArticuloProducir,
						idArticuloFase: this.filtros.idArticuloFase,
						idArea: this.filtros.idArea,
						idReporto: this.filtros.idReporto,
						idResponsable: this.filtros.idResponsable,
						idOEEFactor: 3,
						//idTurno: this.filtros.idTurno,
						bloqueoProduccion: this.filtros.bloqueoProduccion,
						inicio: this.filtros.inicio,
						fin: this.filtros.fin,
						tipoParo: this.filtros.idTipoParo,
						idMaquinaIns: this.filtros.instancias,
					},
				})
				.then((response) => {
					this.setDefaultsChart(response.data.categories);
					this.series = [...response.data.series]
    				  .sort((a, b) => b.data[0] - a.data[0]);
				})
				.catch((error) => {
					this.setDefaultsChart();
					this.series = [];
				})
				.finally(() => {
					this.loading = false;
				});
		},
		descargarPDF(idParo) {
			const url = `/Paros/ReportePDFImagenes?IdParo=${idParo}`;
			const fileName = `ReporteParo.pdf`;
			this.$utils.axios.downloadFile(
				url,
				"GET",
				fileName, // Nombre del archivo con ID y fecha
				"application/pdf" // Tipo MIME para PDF
			);
		},
		setDefaultsChart(categories = []) {
			this.chartOptions = {
				chart: {
					type: "bar",
					height: 350,
					stacked: false,
					events: {
						dataPointSelection: async (event, chartContext, config) => {
							const categoria = this.chartOptions.xaxis.categories[config.dataPointIndex];
							const serie = this.series[config.seriesIndex].name;
							const valor = this.series[config.seriesIndex].data[config.dataPointIndex];
							const idParoTipo = this.series[config.seriesIndex].metaData?.[config.dataPointIndex];

							this.selectedData = { category: categoria, serie, valor };

							// Abre el diálogo de inmediato
							this.dialogVisible = true;

							// Prepara loading y limpia datos
							this.loading = true;
							this.paros = [];
							this.paros_total = 0;

							try {
								const response = await axios.get("/Paros/GraficaParosFotos", {
								params: {
									paginar: false,
									idParoTipo: idParoTipo,
									idSubParoTipo: this.filtros.idSubParoTipo,
									idTrabajoOrden: this.filtros.clave,
									idArticuloProducir: this.filtros.idArticuloProducir,
									idArticuloFase: this.filtros.idArticuloFase,
									idArea: this.filtros.idArea,
									idReporto: this.filtros.idReporto,
									idResponsable: this.filtros.idResponsable,
									idOEEFactor: 3,
									bloqueoProduccion: this.filtros.bloqueoProduccion,
									inicio: this.filtros.inicio,
									fin: this.filtros.fin,
									tipoParo: this.filtros.idTipoParo,
									idMaquinaIns: this.filtros.instancias,
								},
								});

								this.paros = (response.data || []).map(p => ({
								...p,
								proceso: `Fase: ${p.articuloFase || 'N/D'}`,								
								reportadoPorOperadores: (p.reportadoPor?.length > 0)? p.reportadoPor: (p.operadoresReales?.length > 0 ? p.operadoresReales : ['Sin definir']),
								maquina: {
									marca: p.marca || 'N/D',
									modelo: p.modelo || 'N/D',
									codigo: p.codigo || 'N/D'
								}
								}));
								this.paros_total = this.paros.length;
  								this.paros_actual_page = 1;
							} catch (error) {
								console.error("Error al obtener paros relacionados:", error);
							} finally {
								this.loading = false;
							}
						}
					},
					toolbar: {
						show: true,
					},
					zoom: {
						enabled: true,
					},
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							legend: {
								position: "bottom",
								offsetX: -10,
								offsetY: 0,
							},
						},
					},
				],
				 plotOptions: {
					bar: {
						horizontal: false,
						distributed: true,     // un color por barra
						columnWidth: "60%",    // ancho relativo de cada barra
						dataLabels: {
						position: "center"       // muestra el valor encima de cada barra
						}
					}
					},
					dataLabels: {
					enabled: true,
					style: {
						fontSize: "12px",
						fontWeight: 600,
						colors: ["#000"]
					}
				},
				xaxis: {
					type: "category",
					categories,
					labels: {
						show: true,
						style: {
						fontSize: "4px",  // tamaño legible
						fontWeight: 500
					}
				 }
				},
				legend: {
					position: "right",
					offsetY: 40,
				},
				fill: {
					opacity: 1,
				},
				yaxis: {
					min: 0,
					tickAmount: 5,
					forceNiceScale: true  // ApexCharts buscará “nice” ticks
					}
			};
		},
		async verParoPreview(idParo) {
			const res = await axios.get(`/Paros/PreviewParoPdf/${idParo}`, {
				responseType: 'blob'
			});
			const blob = new Blob([res.data], { type: 'application/pdf' });
			const url = URL.createObjectURL(blob);

			// Abre en nueva pestaña
			window.open(url, '_blank');
		}
	},
};
</script>